import { render } from "./Meigaranewsrecent.vue?vue&type=template&id=1775837c&scoped=true"
import script from "./Meigaranewsrecent.vue?vue&type=script&lang=js"
export * from "./Meigaranewsrecent.vue?vue&type=script&lang=js"

import "./Meigaranewsrecent.vue?vue&type=style&index=0&id=1775837c&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1775837c"]])

export default __exports__